import React, { useCallback } from 'react';
import { AppContainer } from 'components/AppContainer/AppContainer';
import { Alert, Container, Button, Text } from '@groupelacentrale/contact-storybook';
import { SERVICE_DOWN } from 'api/errors';
import { useHistory } from 'react-router';
import '../Deposit/Deposit.scss';
import './ErrorPage.scss';

interface Props {
  error?: Error;
}

export const ErrorPage: React.FC<Props> = ({ error }) => {
  const history = useHistory();

  const reset = useCallback(() => {
    history.goBack();
  }, [history]);

  // eslint-disable-next-line no-console
  console.log(error);

  return (
    <AppContainer>
      <main className="deposit-page error-page">
        <div className="container-solo">
          <Container className="error-page-content" shadowed paddings="noP" backgroundColor="bgWhite">
            <div className="section">
              <Alert type="error">{SERVICE_DOWN}</Alert>
            </div>
            <div className="section">
              <Text color="primary" size="large" weight="bold">
                Besoin d&apos;aide ?
              </Text>
              <Text color="primary">
                Nos conseillers vous répondent au <b className="phone-number">01 77 49 01 86</b>
                &nbsp;(prix d&apos;un appel local depuis un poste fixe) du <b>lundi au vendredi de 9h à 18h</b>
              </Text>
            </div>
            <div className="section actions">
              <Button label="Retour" theme="quaternary" type="button" onClick={reset} />
            </div>
          </Container>
        </div>
      </main>
    </AppContainer>
  );
};
